import React, { MouseEvent, ReactElement } from 'react';

import { Failure } from '../../../../../../types/entity.types';

import Modal from '../../../../../common/modal/Modal';
import Button from '../../../../../common/button/Button';

import '../team-modals.scss';

type FailuresProps = {
  failures?: Failure[];
};

const Failures = ({ failures }: FailuresProps): ReactElement => {
  return (
    <div className="team-upload-failure-modal__failures visible-scrollbar">
      {failures?.map(
        (result: Failure, index: number): ReactElement => (
          <p className="team-upload-failure-modal__failure" key={index}>
            Row {result.teamMemberExcel.rowNumber}: {result.failureReasons.join(', ')}
          </p>
        )
      )}
    </div>
  );
};

type Props = {
  show: boolean;
  close: (event: MouseEvent<HTMLButtonElement>) => void;
  failures?: Failure[];
};

const TeamUploadFailureModal: ({ show, close, failures }: Props) => ReactElement = ({
  show,
  close,
  failures
}: Props): ReactElement => {
  if (!show) return <React.Fragment />;

  return (
    <Modal show={show}>
      <section className="team-modals">
        <h1 className="team-modals__header">Upload Failure</h1>
        <p className="team-modals__message">We found the following issue(s) while processing the file:</p>

        <Failures failures={failures} />

        <p className="team-modals__message">Please review and update your list.</p>
        <div className="team-modals__button-container">
          <Button text="Okay" onClick={close} />
        </div>
      </section>
    </Modal>
  );
};

export default TeamUploadFailureModal;
